import { render, staticRenderFns } from "./SupplierListApprove.vue?vue&type=template&id=596105e2&"
import script from "./SupplierListApprove.vue?vue&type=script&lang=js&"
export * from "./SupplierListApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports